/**
 * Compute the next account selection after toggling an account.
 *
 * Multi-select (default): toggling adds/removes the account from the set.
 * Single-select (e.g. GA4 properties): picking an account replaces the
 * current selection; clicking the selected account deselects it.
 */
export const nextSelection = (
  current: Set<string>,
  accountId: string,
  singleSelect: boolean,
): Set<string> => {
  if (singleSelect) {
    return current.has(accountId) ? new Set() : new Set([accountId]);
  }

  const next = new Set(current);
  if (next.has(accountId)) {
    next.delete(accountId);
  } else {
    next.add(accountId);
  }
  return next;
};

/**
 * Initial selection when the modal opens and no accounts were previously
 * saved. Multi-select preselects everything; single-select only preselects
 * when there is exactly one account to choose from.
 */
export const initialSelection = (
  accountIds: string[],
  singleSelect: boolean,
): Set<string> => {
  if (singleSelect) {
    return accountIds.length === 1 ? new Set(accountIds) : new Set();
  }
  return new Set(accountIds);
};
